/**
 * Decodes a 42-byte push message into its components:
 * - slot (BigInt)
 * - ephemeralPublicKey (Uint8Array of 32 bytes)
 * - sharedSecretHint (Uint8Array of 2 bytes)
 *
 * @param {Uint8Array} data - 42-byte input buffer
 * @returns {{ slot: bigint, ephemeralPublicKey: Uint8Array, sharedSecretHint: Uint8Array }}
 */
export function decodePushMessage(data) {
  if (!(data instanceof Uint8Array) || data.length !== 42) {
    throw new Error("Expected a Uint8Array of length 42");
  }

  // Extract slot (bytes 0..8 as little-endian)
  const slotView = new DataView(data.buffer, data.byteOffset, 8);
  const slot = slotView.getBigUint64(0, true); // true = little-endian

  // Extract ephemeralPublicKey (bytes 8..40)
  const ephemeralPublicKey = data.slice(8, 40);

  // Extract sharedSecretHint (bytes 40..42)
  const sharedSecretHint = data.slice(40, 42);

  return {
    slot,
    ephemeralPublicKey,
    sharedSecretHint,
  };
}